import { abmConstants } from "../constants";

const defaultState = {
  searchTerm: "",
  isFetching: false, 
  page: 0,
  count: 0,
  list: [],
  filterList: [],
  data: [],
  schema: null,
  item: {
    id: 0,
  },
  loaded: false,
  selectedTab: "propiedades",
  noSavedChanges: {
    state: false,
    values: {},
  },
  flow: null,
  cancel: {},
};

/**
 * @param {*} controller string | nombre del controller de la api 
 * @returns un reducer de operaciones asincronicas
 */
export const reducer = (controller) => (state = defaultState, {type, payload}) => {
  
  const procesarData = (payload, state) => {
    const { value, ...others } = payload;
    return  value ? {...state.item, ...value, ...Object.keys(others).reduce( (prev, curr)=> ({...prev, [curr]: others[curr].value}), {}) } : undefined;
  } 

  const constants = abmConstants(controller);

  switch(type){
    case constants.SCHEMA_FORM.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.SCHEMA_FORM.SUCCESS:
      return {
        ...state,
        isFetching: false, 
      };      
    case constants.SCHEMA_FORM.FAILURE:
      return {
        ...state,
        isFetching: false, 
      }; 
    case constants.SCHEMA.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.SCHEMA.SUCCESS:
      return {
        ...state,
        schema: payload,
        isFetching: false, 
      };      
    case constants.SCHEMA.FAILURE:
      return {
        ...state,
        schema: {fields: []},
        isFetching: false, 
      }; 
    case constants.INDEX.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.INDEX.SUCCESS:
      return {
        ...state,
        list: payload.value,
        page: payload.page,
        count: payload.count,
        isFetching: false, 
      };      
    case constants.INDEX.FAILURE:
      return {
        ...state,
        list: [],
        page: 0,
        count: 0,
        isFetching: false, 
      };      
    case constants.INDEX.UPDATE_ITEM:
      //console.log(payload)
      return {
        ...state,
        list: state.list.map(item => 
          (payload.value && payload.value.id) ? (item.id === payload.value.id ? payload.value : item) : (item.id === payload.id) ? payload : item
        )
      };      
    case constants.INDEX.ADD_ITEM:
      return {
        ...state,
        list: [payload, ...state.list],
        filterList: [payload, ...state.filterList],
      };      
    case constants.LOAD_MORE.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.LOAD_MORE.SUCCESS:
      return {
        ...state,
        list: payload.value.reduce((prev, curr) => prev.find(item => item.id === curr.id) ? prev : [...prev, curr], state.list),
        page: payload.page,
        isFetching: false, 
      };      
    case constants.LOAD_MORE.FAILURE:
      return {
        ...state,
        isFetching: false, 
      };      
    case constants.FILTER.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.FILTER.SUCCESS:
      return {
        ...state,
        filterList: payload.value || [],
        isFetching: false, 
      };      
    case constants.FILTER.FAILURE:
      return {
        ...state,
        filterList: [],
        isFetching: false, 
      };  
    case constants.FILTER.CLEAR:
      return {
        ...state,
        filterList: [],
      };       
    case constants.FILTER.UPDATE_ITEM:
      return {
        ...state,
        filterList: state.filterList.map(item => 
          payload.id ? (item.id === payload.id ? payload : item) : (item.value && item.id === payload.value.id ? payload.value : item)
       ),
      }; 
    case constants.GET_ITEM.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.GET_ITEM.SUCCESS:
      return {
        ...state,
        isFetching: false, 
      };      
    case constants.GET_ITEM.FAILURE:
      return {
        ...state,
        isFetching: false, 
      };  
    case constants.GET_TIMELINE.REQUEST:
      return {
        ...state,
        isFetching: true, 
        loaded: false,
      };
    case constants.GET_TIMELINE.SUCCESS:
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        data: payload,
      };      
    case constants.GET_TIMELINE.FAILURE:
      return {
        ...state,
        isFetching: false, 
        loaded: false,
      };  
    case constants.GET_ENUM.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.GET_ENUM.SUCCESS:
      return {
        ...state,
        isFetching: false, 
      };      
    case constants.GET_ENUM.FAILURE:
      return {
        ...state,
        isFetching: false, 
      };  
    case constants.ADD_ITEM.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.ADD_ITEM.SUCCESS:
      return {
        ...state,
        //list: [payload, ...state.list],
        isFetching: false, 
      };      
    case constants.ADD_ITEM.FAILURE:
      return {
        ...state,
        isFetching: false, 
      };  
    case constants.ADD_FORM.REQUEST:
      return {
        ...state,
        loaded: false,
        isFetching: true, 
      };
    case constants.ADD_FORM.SUCCESS:
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        item: payload.value,
      };      
    case constants.ADD_FORM.FAILURE:
      return {
        ...state,
        loaded: false,
        isFetching: false, 
      };  
    case constants.EDIT_ITEM.REQUEST:
      return {
        ...state,
        isFetching: true, 
      };
    case constants.EDIT_ITEM.SUCCESS:
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        item: procesarData(payload, state) || state.item,
      }; 
    case constants.EDIT_ITEM.FAILURE:
      return {
        ...state,
        isFetching: false, 
      };  

    case constants.EDIT_FORM.REQUEST:

      try{
        state.cancel.editForm();
      }catch(e){
        console.log(e)
      }
      return {
        ...state,
        isFetching: true, 
        loaded: false,
        cancel: {
          ...state.cancel,
          editForm: payload 
        } 
      };
    case constants.EDIT_FORM.SUCCESS:
      return {
        ...state,
        isFetching: false, 
        loaded: true,
        item: procesarData(payload, state) || state.item,
      };
    case constants.EDIT_FORM.FAILURE:
      return {
        ...state,
        loaded: false,
        isFetching: false, 
      };  
      case constants.REMOVE_ITEM.REQUEST:
        return {
          ...state,
          isFetching: true, 
        };
      case constants.REMOVE_ITEM.SUCCESS:
        return {
          ...state,
          list: state.list.filter(x => x.id !== payload.id),
          filterList: state.filterList.filter(x => x.id !== payload.id),
          isFetching: false, 
        };
      case constants.REMOVE_ITEM.FAILURE:
        return {
          ...state,
          isFetching: false, 
        };  
      case constants.LOADED_PROCESSED:
        return {
          ...state,
          loaded: false,
        }
      case constants.SET_SELECTED_TAB:
        return {
          ...state,
          selectedTab: payload,
        }
      case constants.SET_SEARCH_TERM:
        return {
          ...state,
          searchTerm: payload,
        }
      case constants.SET_NO_SAVED_CHANGES:
        return {
          ...state,
          noSavedChanges: payload,
        }
      case constants.SAVE_FLOW:
        return{
          ...state,
          flow: payload,
        }
    default:
      return state;
  }
}

